import './chart.style.less'

import Header from './Header'
import ReactModal from 'react-modal'
import { createContext, useState } from 'react'
import { themeAtom } from '@/jotai/theme.jotai'
import cx from 'classnames'
import { isDark } from '@/utils/darkmode'
import { useAtom } from 'jotai'

export const ChartFullScreenContext = createContext(false)

interface props {
  children: any
  title: string
  chartTypes?: any
  id: string
  isTarget?: boolean
  onTarget?: (value) => void
  periods?: string[]
  onPeriodChange: (period: string) => any
  onChangeMode?: (isFull: boolean) => any
}

function MainWrapper(props: props) {
  const {
    children,
    title,
    chartTypes,
    id,
    isTarget,
    onTarget,
    periods = [],
    onPeriodChange,
    onChangeMode = () => {},
  } = props
  const [isFullScreen, setIsFullScreen] = useState(false)
  const [theme] = useAtom(themeAtom)

  return (
    <>
      <div
        className={cx(
          isDark(theme) && 'dark-container',
          `liveboard-chart-container ${id}`
        )}
      >
        <Header
          onPressFullscreen={() => {
            setIsFullScreen(!isFullScreen)
            onChangeMode(!isFullScreen)
          }}
          title={title}
          chartTypes={chartTypes}
          id={id}
          isTarget={isTarget}
          onTarget={onTarget}
          periods={periods}
          onPeriodChange={onPeriodChange}
        />
        <ChartFullScreenContext.Provider value={false}>
          <div className="chart-wrapper">{children}</div>
        </ChartFullScreenContext.Provider>
      </div>
      <ReactModal
        isOpen={isFullScreen}
        style={{
          content: {
            border: '1px solid gray',
            padding: 0,
            inset: '15px',
            borderRadius: '18px',
            display: 'flex',
            flexDirection: 'column',
          },
          overlay: {
            zIndex: 99,
          },
        }}
      >
        <div
          className={cx(
            isDark(theme) && 'dark-container',
            'liveboard-chart-container liveboard-chart-container-full'
          )}
        >
          <Header
            id={id}
            onPressFullscreen={() => {
              setIsFullScreen(!isFullScreen)
              onChangeMode(!isFullScreen)
            }}
            title={title}
            chartTypes={chartTypes}
            isTarget={isTarget}
            onTarget={onTarget}
            periods={periods}
            onPeriodChange={onPeriodChange}
          />
          <ChartFullScreenContext.Provider value={true}>
            <div className="chart-wrapper-full">{children}</div>
          </ChartFullScreenContext.Provider>
        </div>
      </ReactModal>
    </>
  )
}
export default MainWrapper
